<script>
	import SvelteFa from "$lib/components/SvelteFa.svelte";
	import { faCircleXmark } from "@fortawesome/free-solid-svg-icons";
	import { slugify, tryEval } from "cando-util";

	export let value;
	export let options;
	export let tabindex = 0;
	export let disabled = false;
	export let name = "new autocomplete value";
	export let handleChange = () => {};
	export let key = "";

	let suggestions = [];

	$: optionsAry = Array.isArray(options || "")
		? [...options]
		: (tryEval(options) && (tryEval(options) || "").split("\n")) || [];

	const filterSuggestions = () => {
		suggestions = optionsAry.filter((o) =>
			(typeof o === "object" ? o.value : o)
				.toLowerCase()
				.includes((value || "").toLowerCase()),
		);
	};

	const setSuggestion = (s) => {
		value = s;
		suggestions = [];

		const inputElement = document.getElementById(
			`autocomplete-input-${slugify(name)}`,
		);

		inputElement.dispatchEvent(new Event("change", { bubbles: true }));
	};

	const onBlur = (e) => {
		setTimeout(() => {
			suggestions = [];
		}, 100);
	};

	const resetInput = (e) => {
		value = "";
		suggestions = [];
		handleChange(e);
	};
</script>

<div class="w-full ml-2 sm:ml-4">
	<div class="relative flex w-full">
		<input
			class="w-full input input-bordered"
			type="text"
			{name}
			{key}
			id={`autocomplete-input-${slugify(name)}`}
			{tabindex}
			bind:value
			on:focus={filterSuggestions}
			on:input={filterSuggestions}
			on:change={handleChange}
			on:blur={onBlur}
			autocomplete="off"
			aria-autocomplete="none"
			{disabled}
		/>
		<button
			{tabindex}
			class={`ml-2 sm:ml-4 ${disabled ? "opacity-50" : ""}`}
			on:click|preventDefault={resetInput}
			{disabled}
			{key}
		>
			<SvelteFa icon={faCircleXmark} size="1.5x" />
		</button>
	</div>
	{#if suggestions.length > 0}
		<ul class="relative overflow-y-scroll bg-base-100 max-h-48">
			{#each suggestions as suggestion}
				<li>
					<button
						id={`autocomplete-select-${slugify(name)}-${typeof suggestion === "object" ? suggestion.value : suggestion}`}
						class="flex w-full p-2 hover:cursor-pointer hover:bg-base-300 sm:p-4"
						on:mousedown|preventDefault={() =>
							setSuggestion(
								typeof suggestion === "object"
									? suggestion.value
									: suggestion,
							)}
					>
						{#if typeof suggestion.option === "object"}
							<div class="flex gap-2">
								{#if suggestion.option.component}
									<svelte:component
										this={suggestion.option.component}
										{...suggestion.option.props}
									/>
								{/if}
								<div>{suggestion.value}</div>
							</div>
						{:else}
							{suggestion.option}
						{/if}
					</button>
				</li>
			{/each}
		</ul>
	{/if}
</div>
